var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15ZM17.442 8.85091C18.0147 8.1116 18.4489 7.06664 18.2918 6C17.3558 6.06505 16.2616 6.66394 15.6232 7.44456C15.0413 8.15187 14.563 9.20405 14.7498 10.2253C15.7731 10.2573 16.8292 9.64392 17.442 8.85091ZM22.5 18.8844C19.5214 17.7516 19.0442 13.5171 21.9919 11.8918C21.0928 10.7643 19.8293 10.1106 18.6367 10.1106C17.0612 10.1106 16.3951 10.8644 15.3009 10.8644C14.1729 10.8644 13.3159 10.1127 11.9539 10.1127C10.6155 10.1127 9.19087 10.9305 8.28765 12.3286C7.01801 14.2977 7.23458 17.9994 9.29351 21.1529C10.0294 22.2815 11.0127 23.5495 12.2988 23.5608C13.4432 23.5722 13.7665 22.8267 15.3174 22.8184C16.8682 22.8091 17.1628 23.5701 18.3052 23.5577C19.5923 23.5474 20.6299 22.1421 21.3658 21.0135C21.8934 20.205 22.0905 19.7971 22.5 18.8844Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.cee9f915.svg";
export { ForwardRef as ReactComponent };